<template>
  <div>
    <div class="uk-margin ">
      <div class="uk-inline uk-width-1-2">
        <span class="uk-form-icon" uk-icon="icon: search"></span>
        <input
          v-model="search"
          class="uk-input uk-width-1-1"
          type="text"
          placeholder="Search Pantones"
        />
      </div>
    </div>

    <div class="uk-child-width-1-3 uk-child-width-1-6@m" uk-grid>
      <div v-for="(color, index) in pantones" v-show="color.show">
        <a href="#">
          <div
            id="card"
            class="uk-card uk-card-default uk-card-hover uk-card-small uk-margin-medium-bottom"
            @click="selectColor(index)"
          >
            <div class="uk-card-media-top">
              <svg viewBox="0 0 100 52">
                <title>square</title>
                <rect :style="{ fill: color.hex }" width="100" height="52" />
              </svg>
            </div>
            <div class="uk-card-body">
              <p class="uk-margin-small uk-text-muted">
                {{ color.pantone.replace("-", " ").toUpperCase() }}
              </p>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import PantoneService from "@/services/PantoneService";

for (const i of PantoneService) {
  i.show = true;
}

export default {
  name: "PantoneSelect",

  data() {
    return {
      search: "",
      fill: "#123456",
      pantones: PantoneService
    };
  },

  watch: {
    search() {
      for (const i of this.pantones) {
        i.show = this.search
          ? i.pantone
              .replace("-", "")
              .indexOf(this.search.toLowerCase().replace(" ", "")) > -1
          : true;
      }
    }
  },

  methods: {
    selectColor(pantoneIndex) {
      let pantone = this.pantones[pantoneIndex];
      this.$emit("pantoneSelected", pantone), (this.search = "");
    },
    clearSearch() {
      this.search = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PantoneSelect.vue